const socialLinks = [
  { icon: "ri-facebook-fill", href: "https://www.facebook.com/ultimate.heating.and.cooling.mechanical.llc", label: "Facebook", color: "hover:bg-[#1877F2]" },
];

export default function CommunitySection() {
  return (
    <section className="py-16 bg-[#F0F4FA]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <span className="text-[#C8102E] text-xs font-bold tracking-[0.2em] uppercase">STAY CONNECTED</span>
        <h2 className="text-2xl font-extrabold text-[#0B2447] mt-3 mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          Follow Ultimate Heating &amp; Cooling
        </h2>
        <p className="text-gray-500 text-sm leading-relaxed mb-8 max-w-lg mx-auto">
          Get seasonal tips, maintenance reminders, promotions, and an inside look at our team at work — all across Connecticut.
        </p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          {socialLinks.map((s) => (
            <a
              key={s.label}
              href={s.href}
              aria-label={s.label}
              className={`w-11 h-11 flex items-center justify-center bg-white border border-gray-200 rounded-full text-gray-500 ${s.color} hover:text-white hover:border-transparent transition-all cursor-pointer`}
            >
              <i className={`${s.icon} text-base`}></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
